<div class="breadcrumb-current"><ng-content /></div>
<div class="select-arrow" *ngIf="!disabled"></div>
